import { Button, Dialog, Tooltip } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import ReactComponent from './ReactComponent';

class InformacoesLogFrontend extends ReactComponent {
    dialogOpen;

    handleClickBotaoLogs = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogOpen: observable,
            handleClickBotaoLogs: action,
            handleCloseDialog: action,
            logsOrdenados: computed
        });
    }

    get logsOrdenados() {
        return this.logStore.logs.slice().reverse();
    }

    render() {
        return (
            <div>
                <Tooltip title={'Exibir logs do frontend'}>
                    <div>
                        <Button
                            variant={'outlined'}
                            color="primary"
                            size="small"
                            onClick={this.handleClickBotaoLogs}
                        >
                            Logs
                        </Button>
                    </div>
                </Tooltip>
                {this.dialogOpen && (
                    <Dialog
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        open={this.dialogOpen}
                    >
                        {this.logsOrdenados.length > 0 ? (
                            this.logsOrdenados.map((log) => (
                                <div
                                    key={this.nextKey}
                                    style={{ display: 'flex' }}
                                >
                                    <div style={{ margin: '10px', whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                                        {log.data}
                                    </div>
                                    <div style={{ flexGrow: '1', margin: '10px' }}>
                                        {log.erro && (
                                            <Fragment>
                                                <div>
                                                    <b>Usuário: </b>
                                                    {log.usuario ? log.usuario.cpf : ''}
                                                </div>
                                                <div>
                                                    <b>Localizacao: </b>
                                                    {log.usuario ? log.usuario.localizacao : ''}
                                                </div>
                                                <div>
                                                    <b>Request URL: </b>
                                                    {log.erro.url}
                                                </div>
                                                <div>
                                                    <b>Request Method: </b>
                                                    {log.erro.method ? log.erro.method.toString().toUpperCase() : ''}
                                                </div>
                                                <div>
                                                    <b>Status Code: </b>
                                                    {log.erro.status}
                                                </div>
                                                <div>
                                                    <b>Dados de Entrada: </b>
                                                    {JSON.stringify(log.erro.body)}
                                                </div>
                                                <div>
                                                    <b>Mensagem: </b>
                                                    {log.erro.mensagem}
                                                </div>
                                                <div>
                                                    <b>Resposta: </b>
                                                    {JSON.stringify(log.erro.resposta)}
                                                </div>
                                            </Fragment>
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <h3 style={{ margin: '20px' }}>Não há logs de erro registrados</h3>
                        )}
                    </Dialog>
                )}
            </div>
        );
    }
}

export default inject('stores')(observer(InformacoesLogFrontend));
